import React, { useEffect, useState } from "react";
import { Button, Spin, Tag, Typography } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import "../styles/global-background.css";
import "../styles/BlogPost.css";
import { useAccount } from "wagmi";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import {
  ShareAltOutlined,
  CalendarOutlined,
  UserOutlined,
  TagOutlined,
} from "@ant-design/icons";
import matter from "gray-matter";

const PostDetail: React.FC = () => {
  const { postId } = useParams<{ postId: string }>();
  const [language, setLanguage] = useState<"en" | "zh">("zh");
  const navigate = useNavigate();

  const [meta, setMeta] = useState<{
    title: string;
    author: string;
    time: string;
    category?: string;
  }>({
    title: "",
    author: "",
    time: "",
    category: "",
  });

  const [content, setContent] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    if (!postId) return;

    fetch(`/posts/${postId}.md`)
      .then((res) => {
        if (!res.ok) throw new Error("404");
        return res.text();
      })
      .then((raw) => {
        const { data, content } = matter(raw);
        setMeta({
          title: data.title || "新闻速递",
          author: data.author || "Nova Crafter Official",
          time: data.time || "Now",
          category: data.category || "N/A",
        });
        setContent(content);
        setLoading(false);
      })
      .catch((err) => {
        console.warn("文章读取失败：", err);
        setNotFound(true);
        setLoading(false);
      });
  }, [postId]);

  if (loading) {
    return (
      <div className="nova-container">
        <div className="nova-grid" />
        <Navbar language={language} />
        <div className="content" style={{ textAlign: "center", padding: "5rem 1rem" }}>
          <Spin size="large" />
        </div>
      </div>
    );
  }

    if (notFound) {
    return (
      <div className="nova-container">
        <div className="nova-grid" />
        <Navbar language={language} />
        <div className="content">
          <div className="post-not-found">
            <h2>{language === 'en' ? 'Post not found' : '文章未找到'}</h2>
            <Button type="primary" onClick={() => navigate('/hub')}>
              {language === 'en' ? 'Back to News' : '返回新闻'}
            </Button>
          </div>
          <Footer language={language} setLanguage={setLanguage} />
        </div>
      </div>
    );
  }

  return (
    <div className="nova-container">
      <div className="nova-grid" />
      <Navbar language={language} />
      <div className="content">
        <div className="post-detail-container">
          <Typography.Title level={1}>{meta.title}</Typography.Title>
          <div className="post-detail-meta">
            <Tag color="purple" icon={<CalendarOutlined />}>{meta.time}</Tag>
            <Tag color="blue" icon={<UserOutlined />}>{meta.author}</Tag>
            <Tag color="green" icon={<TagOutlined />}>{meta.category}</Tag>
            {/* <Button type="link" icon={<ShareAltOutlined />}>
              {language === 'en' ? 'Share' : '分享'}
            </Button> */}
          </div>

          <div className="post-detail-content markdown-content">
            <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
              {content}
            </ReactMarkdown>
          </div>

          <div className="post-detail-navigation">
            <Button onClick={() => navigate('/hub')}>
              {language === 'en' ? '← Back' : '← 返回'}
            </Button>
          </div>
        </div>

        <Footer language={language} setLanguage={setLanguage} />
      </div>
    </div>
  );
};

export default PostDetail;
